import { render, staticRenderFns } from "./SohoBadge.vue?vue&type=template&id=864d2cd4&scoped=true&"
import script from "./SohoBadge.vue?vue&type=script&lang=js&"
export * from "./SohoBadge.vue?vue&type=script&lang=js&"
import style0 from "./SohoBadge.vue?vue&type=style&index=0&id=864d2cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864d2cd4",
  null
  
)

export default component.exports